<template>
  <div class="item" @click="gotoAuthor">
    <img :src="avatar" class="avatar" />
    <span class="nick">{{ name }}</span>
    <span class="work">{{ typeName }} | {{ authorCompany }}</span>
    <span class="followCount">粉丝数 {{ followerNum }}</span>
    <a href="javascript:;" class="btn" @click="gotoAuthor">已关注</a>
  </div>
</template>

<script>
export default {
  name: 'AuthorFollowItem',
  props: {
    authorId: {
      type: Number
    },
    name: {
      type: String
    },
    avatar: {
      type: String
    },
    typeName: {
      type: String
    },
    authorCompany: {
      type: String
    },
    followerNum: {
      type: Number
    }
  },
  methods: {
    gotoAuthor() {
      this.$emit('gotoAuthor')
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 236px;
  height: 226px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  height: 60px;
  margin: 20px auto;
  border-radius: 50%;
}
.nick {
  display: block;
  width: 100%;
  height: 16px;
  color: #262626;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
.work {
  display: block;
  width: 100%;
  height: 16px;
  color: #858585;
  text-align: center;
  margin-top: 7px;
  font-size: 14px;
}
.followCount {
  display: block;
  width: 100%;
  height: 16px;
  color: #858585;
  text-align: center;
  margin-top: 7px;
  font-size: 14px;
}
a.btn {
  display: block;
  width: 80px;
  height: 30px;
  background-color: #ffffff;
  text-align: center;
  border-radius: 2px;
  border: solid 1px #046bcc;
  font-size: 14px;
  color: #046bcc;
  line-height: 30px;
  text-decoration: none;
  margin: 18px auto;
}
// a.btn:hover,
// a.btn:active {
//   opacity: 0.5;
// }
</style>
